import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { setSEO } from "@/lib/api";

export default function About() {
  useEffect(() => {
    setSEO({
      title: "About FEMBOT NEX | Post-Ironic Activewear Manifesto",
      description:
        "FEMBOT NEX is not wellness. It is post-ironic activewear for women who lift, spiral, dissociate, and still look expensive doing it.",
    });
  }, []);

  return (
    <div data-testid="about-page" className="max-w-[1400px] mx-auto px-4 md:px-8 py-16 md:py-24">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="section-label">// MANIFESTO</div>
          <div className="mt-4 font-mono text-[11px] tracking-[0.2em] uppercase text-[#6b6b6b]">
            $ cat about.txt
            <br />
            <span className="blink">loading_void</span>
          </div>
        </div>
        <div className="md:col-span-8">
          <h1 className="font-display text-5xl md:text-7xl leading-[0.9] tracking-tight">
            FEMBOT NEX is <span className="text-[#ff1493]">not wellness</span>.
          </h1>

          <div className="mt-10 space-y-6 text-lg md:text-xl text-white/90 leading-relaxed">
            <p>
              It is not clean girl. It is not here to optimize your morning routine.
            </p>
            <p>
              It is <span className="text-[#ff1493]">post-ironic activewear</span> for women who lift, spiral, dissociate, flirt with collapse, and still look expensive doing it.
            </p>
            <p>
              Born from gym culture, internet rot, dark humor, and cyber-feminine visual language, FEMBOT NEX makes clothes for the girl who is too misanthropic for this — but still showed up.
            </p>
          </div>

          <div className="mt-16">
            <h2 className="font-display text-2xl md:text-3xl tracking-tight mb-6">// Brand Pillars</h2>
            <ol className="space-y-4 md:space-y-2">
              {[
                ["001", "We reject the seasonal cycle. Every piece is a permanent statement."],
                ["002", "The body is not a canvas. It is the void through which cloth speaks."],
                ["003", "Post-irony is not nihilism. It is the discipline of sincerity without apology."],
              ].map(([n, body]) => (
                <li key={n} className="manifesto-row">
                  <span className="manifesto-num">{n}</span>
                  <span className="manifesto-body">{body}</span>
                </li>
              ))}
            </ol>
          </div>

          <div className="mt-16 flex flex-wrap gap-3">
            <Link to="/drop-001" data-testid="about-drop-cta" className="btn-primary">
              Shop Drop 001 <ArrowRight size={14} strokeWidth={1.5} />
            </Link>
            <Link to="/contraband" data-testid="about-contraband-cta" className="btn-outline">
              Enter Contraband
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
